import { useMutation, useQuery } from '@tanstack/react-query';
import { RevenueConfigApi } from 'api/revenue-entries/revenue-config/api';
import { GENERAL_API_STALE } from 'config/query-config';
import { queryClient } from 'queries';
export const REVENUE_CONFIG_KEY = [
    'revenue-config'
];
export const useGetRevenueConfig = (queryOptions)=>{
    return useQuery(REVENUE_CONFIG_KEY, ()=>RevenueConfigApi.getRevenueConfig(), {
        staleTime: GENERAL_API_STALE,
        ...queryOptions !== null && queryOptions !== void 0 ? queryOptions : {}
    });
};
// Alias for consistency with expense configuration
export const useRevenueConfiguration = useGetRevenueConfig;
export const useUpdateRevenueConfig = ()=>{
    return useMutation({
        mutationFn: (revenueConfig)=>RevenueConfigApi.updateRevenueConfig(revenueConfig),
        onMutate: async (revenueConfig)=>{
            await queryClient.cancelQueries({
                queryKey: REVENUE_CONFIG_KEY
            });
            const previousRevenueConfig = queryClient.getQueryData(REVENUE_CONFIG_KEY);
            queryClient.setQueryData(REVENUE_CONFIG_KEY, revenueConfig);
            return {
                previousRevenueConfig
            };
        },
        onError: (_error, _revenueConfig, context)=>{
            queryClient.setQueryData(REVENUE_CONFIG_KEY, context === null || context === void 0 ? void 0 : context.previousRevenueConfig);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries({
                queryKey: REVENUE_CONFIG_KEY
            });
        }
    });
};
